import React from 'react';
import { Styles } from '../../../../config/design/styles';
import AppAnimate from "../../../components/AppAnimate";
import Wallets from "./Wallets";
import Grid from "@mui/material/Grid2";
import { withStyles } from "@mui/styles";
import {useTranslation} from "react-i18next";
import Title from "../../../components/elements/Title";

const WalletsPage = ({ classes }) => {
    const { t } = useTranslation();

    return (
        <AppAnimate animation='transition.slideUpIn' delay={200} title={t('manageWallets')}>
            <Grid container spacing={2} justify="center">
                <Grid item size={12}>
                    <Title align="left" color="text" className="panel-title">{t('manageWallets')}</Title>
                    <Wallets/>
                </Grid>
            </Grid>
        </AppAnimate>
    );
};

export default withStyles(Styles)(WalletsPage);
